import React from 'react';
import PropTypes from 'prop-types';
import { IdealCurveEditorModal } from './IdealCurveEditorModal';
import { curveFromData } from './IdealCurveEditor';
import { IdealCurvePoint } from '../models/IdealCurvePoint';

function pointsFromJs(array) {
  if (array == null) return [];
  return array.map(p => IdealCurvePoint.fromJs(p));
}

class IdealFormInputs extends React.Component {
  static propTypes = {
    methodId: PropTypes.number.isRequired,
    stageId: PropTypes.number.isRequired,
    elementId: PropTypes.number.isRequired,
    elementName: PropTypes.string.isRequired,
    idealColumn: PropTypes.string.isRequired,
    idealValue: PropTypes.string,
    curveFitUrl: PropTypes.string.isRequired,
    elements: PropTypes.arrayOf(PropTypes.object).isRequired,
    extraction_methods: PropTypes.arrayOf(PropTypes.object).isRequired,
    initialPoints: PropTypes.arrayOf(PropTypes.object),
    initialCurve: PropTypes.object,
    initialDependencyElementId: PropTypes.number,
    initialDependencyElementExtractionMethodId: PropTypes.number,
  };

  static defaultProps = {
    CurveEditorModalComponent: IdealCurveEditorModal, // This is just for dependency injection in tests
  };

  constructor(props) {
    super(props);

    const { methodId, stageId, elementId, idealColumn, initialPoints, initialCurve, initialDependencyElementId, initialDependencyElementExtractionMethodId } = this.props;

    this._baseInputName = `method${methodId}_stage${stageId}_element${elementId}_${idealColumn}`;

    this.state = {
      curve: curveFromData(initialCurve),
      points: pointsFromJs(initialPoints),
      dependencyElementId: initialDependencyElementId,
      dependencyElementExtractionMethodId: initialDependencyElementExtractionMethodId,
    };
  }

  _validCurveDefined = () => {
    return (this.state.curve != null) && (this.state.points.length > 0) && (this.state.dependencyElementId != null) && (this.state.dependencyElementExtractionMethodId != null);
  };

  _handleChange = (dependencyElementId, dependencyElementExtractionMethodId, curve, points) => {
    this.setState({
      dependencyElementId: dependencyElementId,
      dependencyElementExtractionMethodId: dependencyElementExtractionMethodId,
      curve: curve,
      points: points || [],
    });
  };

  _handleRemove = () => {
    this.setState({
      dependencyElementId: null,
      dependencyElementExtractionMethodId: null,
      curve: null,
      points: [],
    });
  };

  _renderCurveInputs = () => {
    if (!this._validCurveDefined()) return null;

    const { idealValue } = this.props;
    const baseCurveAttributesName = `${this._baseInputName}_curve_attributes`;

    return (
      <>
        <input type="hidden" name={this._baseInputName} value={idealValue || ''} />
        <input type="hidden" name={`${baseCurveAttributesName}[dependency_element_id]`} value={this.state.dependencyElementId} />
        <input type="hidden" name={`${baseCurveAttributesName}[dependency_element_extraction_method_id]`} value={this.state.dependencyElementExtractionMethodId} />
        <input type="hidden" name={`${baseCurveAttributesName}[curve]`} value={JSON.stringify(this.state.curve.toJs())} />
        <input type="hidden" name={`${baseCurveAttributesName}[points]`} value={JSON.stringify(this.state.points.map(p => p.toJs()))} />
      </>
    );
  };

  render() {
    const { elementName, idealColumn, elements, extraction_methods, curveFitUrl, idealValue, CurveEditorModalComponent } = this.props;

    return (
      <>
        <input type="text" name={this._baseInputName} defaultValue={idealValue || ''} size={8} disabled={this._validCurveDefined()} />
        <CurveEditorModalComponent idealLabel={`${elementName} ${idealColumn}`} elements={elements} extraction_methods={extraction_methods} curveFitUrl={curveFitUrl} onChange={this._handleChange} onRemove={this._handleRemove} initialPoints={this.state.points} initialCurve={this.state.curve} initialDependencyElementId={this.state.dependencyElementId} initialDependencyElementExtractionMethodId={this.state.dependencyElementExtractionMethodId} />
        {this._renderCurveInputs()}
      </>
    );
  }
}

export default IdealFormInputs;
